<template>
  <v-layout row wrap data-qa="noticecashisacloseaccountheader-layout-0wu1rj">
    <v-layout wrap class="ml-2" data-qa="noticecashisacloseaccountheader-layout-etk7fv">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="noticecashisacloseaccountheader-flex-ge108">
        <v-container class="pa-6 pl-12" data-qa="noticecashisacloseaccountheader-container-22o4v7">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="noticecashisacloseaccountheader-flex-y4wze7">
            <v-row no-gutters data-qa="noticecashisacloseaccountheader-row-onpdvb">
              <v-layout row wrap class="pb-2" data-qa="noticecashisacloseaccountheader-layout-w5m3e4">
                <inline-svg
                  class="mt-2"
                  :src="getNavigationIcon()"
                  width="50"
                  height="50"
                  aria-label="Navigation Icon"
                ></inline-svg>
                <font
                  class="display-1 font-weight-thin white--text pt-4 pl-2"
                  >{{ getAccountTypeLabel() }}</font
                >
              </v-layout>
            </v-row>
            <v-row class="pl-4" data-qa="noticecashisacloseaccountheader-row-1re1jh">
              <v-layout wrap data-qa="noticecashisacloseaccountheader-layout-yqq2x4">
                <v-flex lg9 xl9 data-qa="noticecashisacloseaccountheader-flex-ygp2">
                  <v-layout row wrap data-qa="noticecashisacloseaccountheader-layout-616m9">
                    <v-flex xs12 sm6 md6 lg5 xl4 class="px-1" data-qa="noticecashisacloseaccountheader-flex-lfrv5">
                      <font class="subheading font-weight-medium white--text">{{
                        $t("accountDetails.accountNumber")
                      }}</font>
                      <br data-qa="noticecashisacloseaccountheader-br-w837h7">
                      <font class="text-h5 font-weight-bold white--text">{{
                        $formatter.formatAccount(accountNumber)
                      }}</font>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 xl4 class="px-1" data-qa="noticecashisacloseaccountheader-flex-1qrdlp">
                      <font class="subheading font-weight-medium white--text">{{
                          $t("accountDetails.availableBalance")
                      }}</font>
                      <br data-qa="noticecashisacloseaccountheader-br-2gbfma">
                      <font class="text-h5 font-weight-bold white--text">{{
                        $formatter.currency.format(balance, currency)
                      }}</font>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>

export default {
  name: 'NoticeCashIsaCloseAccountHeader',
  props: {
    accountNumber: String,
    currency: String,
    balance: Number,
    accountType: String
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    getAccountTypeLabel () {
      return this.accountType === 'NACC' ? this.$t('accountDetails.noticeAccountsLabel') : this.$t('accountDetails.taxAccountsLabel')
    }
  }
}

</script>
